var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinea2986Ba1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 787.173,
    height: 193.623,
    viewBox: "0 0 787.173 193.623",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_55154",
    "data-name": "Group 55154",
    transform: "translate(-380.191 -330.222)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_53200",
    "data-name": "Group 53200",
    transform: "translate(151.5 24.447)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_5159",
    "data-name": "Line 5159",
    x2: 66.5,
    transform: "translate(422 402.5)",
    fill: "none",
    stroke: "#bcdeff",
    strokeLinecap: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_75992",
    "data-name": "Path 75992",
    d: "M-10664.77-5798.771l8.333,4.657-8.333,4.7Z",
    transform: "translate(11146 6196.813)",
    fill: "#bcdeff",
    stroke: "#bcdeff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_53274",
    "data-name": "Group 53274",
    transform: "translate(689.801 115.447)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_5159-2",
    "data-name": "Line 5159",
    x2: 67.199,
    transform: "translate(407.5 402.5)",
    fill: "none",
    stroke: "#bcdeff",
    strokeLinecap: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_75992-2",
    "data-name": "Path 75992",
    d: "M-10664.77-5798.771l8.333,4.657-8.333,4.7Z",
    transform: "translate(11133 6196.813)",
    fill: "#bcdeff",
    stroke: "#bcdeff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_53272",
    "data-name": "Group 53272",
    transform: "translate(327 24.447)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_5159-3",
    "data-name": "Line 5159",
    x2: 68,
    transform: "translate(407.5 402.5)",
    fill: "none",
    stroke: "#bcdeff",
    strokeLinecap: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_75992-3",
    "data-name": "Path 75992",
    d: "M-10664.77-5798.771l8.333,4.657-8.333,4.7Z",
    transform: "translate(11136 6196.813)",
    fill: "#bcdeff",
    stroke: "#bcdeff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_75994",
    "data-name": "Path 75994",
    d: "M2.1-2.982H27.652A4.453,4.453,0,0,1,32.1,1.471V83.833a4.313,4.313,0,0,0,4.453,4.286H93.236",
    transform: "translate(379.088 338.882)",
    fill: "none",
    stroke: "#bcdeff",
    strokeLinecap: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_76049",
    "data-name": "Path 76049",
    d: "M79.236-2.982H17.688a4.453,4.453,0,0,0-4.453,4.453V83.833a4.313,4.313,0,0,1-4.453,4.286H-17.191",
    transform: "translate(920.396 338.882)",
    fill: "none",
    stroke: "#bcdeff",
    strokeLinecap: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_76038",
    "data-name": "Path 76038",
    d: "M-10664.77-5798.771l8.333,4.657-8.333,4.7Z",
    transform: "translate(11136.437 6220.993)",
    fill: "#bcdeff",
    stroke: "#bcdeff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_76047",
    "data-name": "Path 76047",
    d: "M2.1,88.286H27.652A4.453,4.453,0,0,0,32.1,83.833V1.471a4.453,4.453,0,0,1,4.453-4.453H92.236",
    transform: "translate(379.088 429.882)",
    fill: "none",
    stroke: "#bcdeff",
    strokeLinecap: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_76048",
    "data-name": "Path 76048",
    d: "M79.236,88.286H17.688a4.453,4.453,0,0,1-4.453-4.453V1.471c0-2.459-2.172-5.353-4.632-5.353H2.1",
    transform: "translate(920.396 430.882)",
    fill: "none",
    stroke: "#bcdeff",
    strokeLinecap: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_76050",
    "data-name": "Path 76050",
    d: "M-10664.77-5798.771l8.333,4.657-8.333,4.7Z",
    transform: "translate(11656.069 6129.993)",
    fill: "#bcdeff",
    stroke: "#bcdeff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_76051",
    "data-name": "Path 76051",
    d: "M-10664.77-5798.771l8.333,4.657-8.333,4.7Z",
    transform: "translate(11656.069 6312.261)",
    fill: "#bcdeff",
    stroke: "#bcdeff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinea2986Ba1);
export default __webpack_public_path__ + "static/media/line.a2986ba1.a9053adccd001be63a8c008300ffe1ae.svg";
export { ForwardRef as ReactComponent };